import flatpickr from "flatpickr";
import {Czech} from "flatpickr/dist/l10n/cs";
import {English} from "flatpickr/dist/l10n/uk";
import {Slovak} from "flatpickr/dist/l10n/sk";

export default function(root) {
	const lang = document.querySelector('html').getAttribute('lang')
	let locale = Czech
	if (lang === 'sk') {
		locale = Slovak
	} else if (lang === 'en') {
		locale = English
	}

	Array.from(root.querySelectorAll('input[data-flatpickr]')).forEach(el => flatpickr(el, {
		locale: locale,
		enableTime: false,
		dateFormat: 'j. n. Y',
		minDate: el.dataset.minDate ? el.dataset.minDate : null,
		allowInput: true
	}))

	Array.from(root.querySelectorAll('input[data-flatpickr-time]')).forEach(el => flatpickr(el, {
		locale: locale,
		enableTime: true,
		noCalendar: true,
		dateFormat: 'H:i',
		defaultHour: el.dataset.hour ? el.dataset.hour : 9,
		minDate: el.dataset.minDate ? el.dataset.minDate : null,
		allowInput: true
	}))

	Array.from(root.querySelectorAll('input[data-flatpickr-datetime]')).forEach(el => flatpickr(el, {
		locale: locale,
		enableTime: true,
		dateFormat: 'j. n. Y H:i',
		defaultHour: el.dataset.hour ? el.dataset.hour : 9,
		minDate: el.dataset.minDate ? el.dataset.minDate : null,
		allowInput: true
	}))
}
